import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { DefaultEditor } from 'ng2-smart-table';

@Component({
  selector: 'cell-datepicker',
  templateUrl: './cell-datepicker.component.html',
  styleUrls: ['./cell-datepicker.component.scss']
})
export class CellDatepickerComponent extends DefaultEditor implements OnInit {

  fecha:any;
  constructor() {
    super();
  }

  ngOnInit(): void {


    if(this.cell.newValue){

      this.fecha = new Date(this.cell.newValue);
      console.log(this.fecha)
    }
  }

  onChange(event){
    console.log(moment(event).unix());
    this.cell.newValue = moment(event).unix()*1000;

  }

}
